import React, { Component } from "react";
import PropTypes from "prop-types";
import { BlockPicker } from "react-color";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";

export class ColourPickerSingleDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    primaryColour: "#000000",
  };

  render() {
    const colours = [
      "#000000",
      "#ff1744",
      "#f50057",
      "#d500f9",
      "#651fff",
      "#3d5afe",
      "#2979ff",
      "#00b0ff",
      "#33eaff",
      "#1de9b6",
      "#00e676",
      "#76ff03",
      "#c6ff00",
      "#ffea00",
      "#ffc400",
      "#ff9100",
      "#ff3d00",
    ];
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="edit-title-dialog-title"
          aria-describedby="edit-title-dialog-description"
        >
          <DialogTitle id="edit-title-dialog-title">
            <Trans i18nKey="colour_picker_header"></Trans>
          </DialogTitle>
          <DialogContent id="edit-title-dialog-description">
            <Trans i18nKey="colour_picker_primary_colour"></Trans>
            <BlockPicker
              id="primary"
              color={this.state.primaryColour}
              colors={colours}
              triangle="hide"
              onChangeComplete={this.primaryColourSelected}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="primary">
              <Trans i18nKey="global_cancel"></Trans>
            </Button>
            <Button onClick={this.submitDialog} color="primary">
              <Trans i18nKey="global_save"></Trans>
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  submitDialog = () => {
    this.props.onSubmit(this.state.primaryColour);
  };

  primaryColourSelected = (colour) => {
    this.setState({ primaryColour: colour.hex });
  };
}

export default ColourPickerSingleDialog;
